import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { InsuranceType, Address, PersonalInfo } from "@/components/sections/quote/types";

export const useQuoteForm = () => {
  const { toast } = useToast();
  const [step, setStep] = useState(1);
  const [selectedType, setSelectedType] = useState<InsuranceType | "">("");
  const [address, setAddress] = useState<Address>({
    street: "",
    city: "",
    state: "",
    zipCode: ""
  });
  const [personalInfo, setPersonalInfo] = useState<PersonalInfo>({
    firstName: "",
    lastName: "",
    email: "",
    phone: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setAddress(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePersonalInfoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPersonalInfo(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const resetForm = () => {
    setSelectedType("");
    setAddress({
      street: "",
      city: "",
      state: "",
      zipCode: ""
    });
    setPersonalInfo({
      firstName: "",
      lastName: "",
      email: "",
      phone: ""
    });
    setStep(1);
  };

  return {
    step,
    setStep,
    selectedType,
    setSelectedType,
    address,
    handleAddressChange,
    personalInfo,
    handlePersonalInfoChange,
    isSubmitting,
    setIsSubmitting,
    resetForm,
    toast
  };
};